<template lang="html">
  <div class="container" :class="{'is-pop':isFilter}">

    <div class="header">
      <!--<img src="../assets/img/topimg1.png" alt="">-->
      <i class="icon-fanhui icon iconfont"  v-if="numberlData=='one'"  @click="returnHome"></i>
      <i class="icon-fanhui icon iconfont" v-if="numberlData=='two'||numberlData=='three'"  @click="goback"></i>
      <p class="text" v-if="numberlData=='one'">{{ type == 1 ? '销售回款排名' : '销售排名'}}</p>
      <p class="text" v-if="numberlData=='two'">{{ type == 1 ? '区域回款排名' : '区域销售排名'}}</p>
      <p class="text" v-if="numberlData=='three'">{{ type == 1 ? '小组回款排名' : '小组销售排名'}}</p>

      <!-- <img src="../assets/img/time.png" alt="" class="time" @click="timePopupVisible = true"> -->
      <i class="icon iconfont icon-shaixuan time" @click="filter" ></i>
      <!-- <p  v-if='numberlData=="one"' class="filter-area">{{region_list[u_region[0]]}}</p> -->
      <p  v-if='numberlData=="one"' class="filter-area">{{c_region[0]=='0'?'全部':getCurrentRegion()}}</p>

      <p class="filter-time">{{begin_time}}-{{end_time}}</p>
      <div class="borbox outside">
        <div class="borbox inside">
          <p class="price" v-if="numberlData=='one'"> <span class="unit">¥</span>{{ type == 1 ? backTotal :saleTotal}}<span class="unit">(万)</span></p>
          <p class="price" v-if="numberlData=='two'"> <span class="unit">¥</span>{{ type == 1 ? backTotal1 : saleTotal1 }}<span class="unit">(万)</span></p>
          <p class="price" v-if="numberlData=='three'"> <span class="unit">¥</span>{{ type == 1 ? itemBackTotal : itemSaleTotal }}<span class="unit">(万)</span></p>

          <p class="title">{{type == 1 ? '总回款额' : '总销售额' }}</p>
          <!-- <p class="bor-time">{{currentTime.name}}</p> -->
        </div>
      </div>

      <div class="caseleft">
        <p v-if="numberlData=='one'" :class="{'yes':type == 1}" @click="changeType(1)">回款排名</p>
        <p v-if="numberlData=='two'" :class="{'yes':type == 1}" @click="changeType(1)">区域回款排名</p>
        <p v-if="numberlData=='three'" :class="{'yes':type == 1}" @click="changeType(1)">小组回款排名</p>
      </div>
      <span class="line"></span>
      <div class="caseright">
        <p v-if="numberlData=='one'" :class="{'yes':type == 2}" @click="changeType(2)">销售排名</p>
        <p v-if="numberlData=='two'" :class="{'yes':type == 2}" @click="changeType(2)">区域销售排名</p>
        <p v-if="numberlData=='three'" :class="{'yes':type == 2}" @click="changeType(2)">小组销售排名</p>
      </div>

    </div>
    <!-- 回款排名 -->
    <div v-if="type == 1">
      <nodata v-if="!backs.length&&!b_list.length" ></nodata>
      <div class="listbox">
        <ul v-if="numberlData=='one'">
          <li v-for="item in backs" @click="showDeatil(1,item)">
            <div class="title">
              <img src="../assets/img/1.png" alt="" v-if="item.sort == 1">
              <img src="../assets/img/2.png" alt="" v-if="item.sort == 2">
              <img src="../assets/img/3.png" alt="" v-if="item.sort == 3">
              <p v-if="item.sort > 3 ">{{item.sort}}</p>
              <p style="padding-left:10%;">{{item.name}}</p>
              <span >{{item.region}} &nbsp; 项目数：{{item.num}}</span>
              <div class="rightbox">
                <span>¥</span>
                <p>{{item.b_money?(item.b_money):'0.00'}}</p>
                <span>(万)</span>
              </div>
            </div>
          </li>
        </ul>

        <ul v-if="numberlData=='two'">
          <li v-for="(item,key) in b_list" @click="showDeatil1(item,2)">
            <div class="title">
              <img src="../assets/img/1.png" alt="" v-if="key == 0">
              <img src="../assets/img/2.png" alt="" v-if="key == 1">
              <img src="../assets/img/3.png" alt="" v-if="key == 2">
              <p v-if="key >2 ">{{key+1}}</p>
              <p style="padding-left:10%;">{{item.name}}</p>
              <span > &nbsp; 项目数：{{item.num}}</span>
              <div class="rightbox">
                <span>¥</span>
                <p>{{item.value.toFixed(2)}}</p>
                <span>(万)</span>
              </div>
            </div>
          </li>
        </ul>
         <ul v-if="numberlData=='three'">
          <li v-for="(item,key) in b_list"  @click="goItemDetail(item.region,1)">
            <div class="title">
              <img src="../assets/img/1.png" alt="" v-if="key == 0">
              <img src="../assets/img/2.png" alt="" v-if="key == 1">
              <img src="../assets/img/3.png" alt="" v-if="key == 2">
              <p v-if="key >2 ">{{key+1}}</p>
              <p style="padding-left:10%;">{{item.name}}</p>
              <span > &nbsp; 项目数：{{item.num}}</span>
              <div class="rightbox">
                <span>¥</span>
                <p>{{item.value.toFixed(2)}}</p>
                <span>(万)</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>


    <!-- 销售排名 -->
    <div v-if="type == 2">
      <!-- <p v-if="!sales.length " style="text-align:center;padding-top:20px;background-color:#fff;">暂无数据</p> -->
      <!-- <nodata v-if="!sales.length&&!sales1.length&&itemSale.length"></nodata> -->
      <div class="listbox">
       <div  v-if="numberlData=='one'">
          <ul v-if="numberlData=='one'">
          <li v-for="item in sales" @click="showDeatil(2,item)">
            <div class="title">
              <img src="../assets/img/1.png" alt="" v-if="item.sort == 1">
              <img src="../assets/img/2.png" alt="" v-if="item.sort == 2">
              <img src="../assets/img/3.png" alt="" v-if="item.sort == 3">
              <p v-if="item.sort > 3 ">{{item.sort}}</p>
              <p style="padding-left:10%;">{{item.name}}</p>
              <span>{{item.region}} &nbsp;项目数：{{item.num}}</span>

              <div class="rightbox">
                <span>¥</span>
                <p>{{item.t_money?(item.t_money):'0.00'}}</p>
                <span>(万)</span>
              </div>
            </div>
          </li>
        </ul>
        <nodata v-if="!sales.length"></nodata>
       </div>
       <div v-if="numberlData=='two'">
          <ul v-if="numberlData=='two'">
          <li v-for="(item,key) in sales1" @click="showDeatil1(item,1)">
            <div class="title">
              <img src="../assets/img/1.png" alt="" v-if="key == 0">
              <img src="../assets/img/2.png" alt="" v-if="key == 1">
              <img src="../assets/img/3.png" alt="" v-if="key == 2">
              <p v-if="key>2">{{key+1}}</p>
              <p style="padding-left:10%;">{{item.name}}</p>
              <span> 项目数：{{item.num}}</span>

              <div class="rightbox">
                <span>¥</span>
                <p>{{item.value.toFixed(2)}}</p>
                <span style="">(万)</span>
              </div>
            </div>
          </li>
        </ul>
        <nodata v-if="!sales1.length"></nodata>
       </div>
       <div v-if="numberlData=='three'">
          <ul v-if="numberlData=='three'">
          <li v-for="(item,key) in itemSale"  @click="goItemDetail(item.region,2)" >
          <div class="title">
            <img src="../assets/img/1.png" alt="" v-if="key == 0">
            <img src="../assets/img/2.png" alt="" v-if="key == 1">
            <img src="../assets/img/3.png" alt="" v-if="key == 2">
            <p v-if="key>2">{{key+1}}</p>
            <p style="padding-left:10%;">{{item.name}}</p>
            <span> 项目数：{{item.num}}</span>

            <div class="rightbox">
              <span>¥</span>
              <p>{{item.value.toFixed(2)}}</p>
              <span style="">(万)</span>
            </div>
          </div>
        </li>
        </ul>
       <nodata v-if="!itemSale.length"></nodata>
       </div>
      </div>

    </div>

    <div  class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <div  class="selbox" v-if="isFilter"><p >筛选</p>

      <p  class="content">
        时间
      </p>
      <ul  class="listtime">
        <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
      </ul>


      <p v-if="numberlData=='one'"  class="content">
        区域
      </p>
      <!-- <ul  class="listtime" v-if="numberlData=='one'" >
        <li :class="{'true': index == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(item.id)" >{{item.name}}</li>
      </ul> -->
       <ul  class="listtime" v-if="numberlData=='one'" >
        <li :class="{'true': item.id == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(item.id)" :key="item.id">{{item.name}}</li>
      </ul>



      <p  class="btnyes" @click="confirmFilter">确定</p>
    </div>


  </div>
</template>

<script>
  // import config from '../fetch/config'
  import { Popup, Picker } from 'mint-ui'
  import nodata from './public/nodata'
  import Vue from 'vue'
  import slotsList from '../assets/js/slotsList'

  Vue.component(Popup.name, Popup)
  Vue.component(Picker.name, Picker)

  import dateChange from '../mixins/dateChange.js'
  import regionChange from '../mixins/regionChange.js'

  export default {
    mixins: [dateChange, regionChange],
    components: {
      nodata
    },
    data() {
      return {
        type: 1, //默认类型
        numberlData: JSON.parse(window.localStorage.getItem('numberlData')),

        isFilter: false, //过滤

        begin_time: null,

        end_time: null,

        u_region: [0], //过滤地区

        currentTime: null,

        backTotal: null,
        backTotal1: null,

        backs: [],
        b_list: [],

        saleTotal: null,
        saleTotal1: null,
        itemBackTotal: null,//小组
        itemSaleTotal: null,
        sales: [],
        sales1: [],
        itemSale: [],// 小组销售
        slots: slotsList.Monthslots(), //日期选择

        originType: null,
      }
    },
    methods: {
      returnHome() {//回款排行按钮
        if (this.originType == 2) {
          this.$router.push({ name: 'sales' })
        } else {
          this.$router.push({ name: 'homepage' })
          // let data = {
          //   begin_time: this.begin_time,
          //   end_time:this.end_time
          // }
          // window.localStorage.setItem( 'drillData', JSON.stringify(data) )
        }

      },
      goback() {//区域销售排行返回
        this.$router.go(-1)
      },

      changeType(type) { //改变销售排名或者回款排名
        this.type = type
        let data = {
          begin_time: this.begin_time,
          end_time: this.end_time,
          u_region: this.u_region
        }
        if (type == 1) {
          data.type = 'backMoney'
        } else {
          data.type = 'saleMoney'
        }
        this.getData(type, data)
      },

      getTime() {
        var d = new Date();
        var y = d.getFullYear()
        var m = d.getMonth() + 1
        this.begin_time = this.end_time = `${y}/${m}`
      },

      getData(type, data) { //获取数据
        // this.$notice.loading()
        //新增参数(finance_group)
        // if(window.localStorage.getItem('finance_group')){
        //   data.finance_group=window.localStorage.getItem('finance_group')
        // }
        if (JSON.parse(window.localStorage.getItem('numberlData')) == 'one') {
          // this.$http.getSaleSort(data).then(res => {
          //   if (type == 1) {
          //     this.backTotal = res.data.total
          //     this.backs = res.data.backs
          //   } else {
          //     this.saleTotal = res.data.total
          //     this.sales = res.data.pc
          //   }
          //   this.$notice.loading(false)
          // })
          if (type == 1) {
            this.$http.getBackRankSort(data).then(res => {
              this.backTotal = res.data.total
              this.backs = res.data.backs
              this.$notice.loading(false)
            })
          } else {
            this.$http.getSaleRankSort(data).then(res => {
              this.saleTotal = res.data.total
              this.sales = res.data.pc
              this.$notice.loading(false)
            })
          }
        }
        if (JSON.parse(window.localStorage.getItem('numberlData')) == 'two') {
          this.$http.getHomePagePie(data).then(res => { //获取各区域签约金额占比与回款占比
            if (type == 1) {
              this.backTotal1 = res.data.b_count
              this.b_list = res.data.b_list

            } else {
              this.saleTotal1 = res.data.t_count
              this.sales1 = res.data.t_list//区域回款金额
            }
            this.$notice.loading(false)
          })
        }
        if (JSON.parse(window.localStorage.getItem('numberlData')) == 'three') {
          this.$http.getItems(data).then(res => { //获取各区域签约金额占比与回款占比
            if (type == 1) {
              this.itemBackTotal = res.data.b_count
              this.b_list = res.data.b_list
            } else {
              this.itemSaleTotal = res.data.t_count
              this.itemSale = res.data.t_list//区域回款金额
            }
            this.$notice.loading(false)
          })
        }

      },

      confirmFilter() { // 过滤选择确定
        this.begin_time = this.c_begin_time
        this.end_time = this.c_end_time
        this.u_region = this.c_region
        this.u_item
        let data = {
          type: this.type == 1 ? 'backMoney' : 'saleMoney',
          begin_time: this.begin_time,
          end_time: this.end_time,
          u_region: this.u_region,
          item: this.u_item,
        }
        this.isFilter = false
        this.getData(this.type, data)

        this.$emit('noFilter')
      },

      showDeatil(type, item) {  //显示详情
        let data = {
          id: item.uid,
          begin_time: this.begin_time,
          end_time: this.end_time
        }
        window.localStorage.setItem('drillData', JSON.stringify(data))
        this.$router.push({ name: 'backdetail' })
      },
      showDeatil1(item, type) { // echarts =》 钻取页
        let data = {
          begin_time: this.begin_time,
          end_time: this.end_time,
          region: [item.region]
        }
        this.toSignDrill(data, type)
      },
      goItemDetail(item, type) {
        console.log('type', type)
        let itemData = {
          begin_time: this.begin_time,
          end_time: this.end_time,
          //  region: [item.region],
          item: item,
          //  item:[item] ,

          type: type
        }
        this.$router.push({ name: 'itemdrill', query: { itemData: JSON.stringify(itemData) } })
      },

      toSignDrill(data, type) { // 查看签约钻取详情
        data.type = type  // type:1 签约 2:回款
        data.origin = 2
        window.localStorage.setItem('drillData', JSON.stringify(data))
        this.$router.push({ name: 'bsdrill' })
      },
      cancel() { //点击阴影取消
        this.c_region = this.u_region
        this.isFilter = false
        this.$emit('noFilter')
      },
      filter() { //显示过滤弹窗
        this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
        this.isFilter = true
        this.$emit('inFilter')
      },
    },
    created() {
      let originData = JSON.parse(window.localStorage.getItem('drillData'))
      this.originType = originData.type
      this.begin_time = originData.begin_time
      this.end_time = originData.end_time

      let data = {
        type: 'backMoney',
        begin_time: this.begin_time,
        end_time: this.end_time,
        u_region: this.u_region
      }

      this.getData(1, data)

    },

  }
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fafafa;
  }
  .container.is-pop {
    height: 90vh;
    overflow: hidden;
  }
  .header {
    width: 100%;
    font-size: 0.375rem;
    height: 6.875rem;
    position: relative;
    margin-bottom: 0.3125rem;
    background: url("../assets/img/topimg1.png") no-repeat;
    background-size: 100% 100%;
  }

  .text {
    font-size: 0.4375rem;
    color: #333;
    text-align: center;
    position: absolute;
    top: 3%;
    left: 0;
    right: 0;
  }

  .filter-area,
  .filter-time {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 13%;
    font-size: 14px;
    color: #666;
  }
  .filter-time {
    top: 22%;
  }
  .line {
    border: 1px solid #f0f0f0;
    position: absolute;
    bottom: 2%;
    left: 50%;
    height: 0.4375rem;
    right: 0;
    width: 0;
  }

  .caseleft {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50%;
    text-align: center;
    font-family: PingFangSC-Regular;
    color: #666666;
    font-size: 0.4375rem;
    font-weight: 500;
    height: 1.03125rem;
    line-height: 1.03125rem;
  }
  .caseleft p {
    width: 60%;
    text-align: center;
    margin: auto;
    height: 100%;
  }

  .yes {
    border-bottom: 0.0625rem solid #5482d2;
    color: #5482d2;
  }

  .caseright {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 50%;
    text-align: center;
    font-family: PingFangSC-Regular;
    color: #666666;
    font-size: 0.4375rem;
    font-weight: 500;
    height: 1.03125rem;
    line-height: 1.03125rem;
  }
  .caseright p {
    width: 60%;
    text-align: center;
    margin: auto;
    height: 100%;
  }

  .borbox {
    border: 1px solid #dde5f5;
    width: 3.81875rem;
    height: 3.81875rem;
    border-radius: 50%;
  }
  .borbox.outside {
    position: absolute;
    top: 2.1625rem;
    left: 0;
    right: 0;
    margin: auto;
  }
  .borbox.inside {
    width: 3.44375rem;
    height: 3.44375rem;
    margin: 0.16rem auto;
    border: 0.09375rem solid #5482d2;
  }
  .borbox.inside .price {
    color: #5482d1;
    font-size: 0.6075rem;
    text-align: center;
    margin-top: 1rem;
  }
  .borbox.inside .unit {
    font-size: 0.375rem;
  }
  .borbox.inside .title {
    text-align: center;
    background: transparent;
    color: #999999;
    margin-top: 0.1875rem;
    font-size: 0.375rem;
    line-height: 0.25rem;
  }
  .borbox.inside .bor-time {
    text-align: center;
    background: transparent;
    color: #5482d1;
    margin-top: 0.25rem;
    font-size: 0.375rem;
    line-height: 0.25rem;
  }
  .listbox {
    width: 100%;
  }
  .listbox ul {
    width: 96%;
    margin: auto;
  }
  .listbox ul li {
    width: 100%;
    position: relative;
    margin-bottom: 0.15625rem;
  }
  .title {
    color: #333;
    line-height: 0.875rem;
    position: relative;
    font-size: 0.4375rem;
    background: #fff;
  }
  .title p:first-child {
    padding-left: 3%;
    padding-right: 2%;
    color: #333333;
    font-size: 0.34375rem;
    float: left;
  }
  .title span {
    font-size: 0.34375rem;
    color: #949494;
    padding-left: 10%;
  }
  .title img {
    width: 0.6875rem;
    height: 0.8125rem;
    float: left;
    margin-left: 1%;
  }
  .rightbox {
    position: absolute;
    width: 35%;
    top: 25%;
    right: 2%;
    text-align: right;
    font-size: 0.5625rem;
    font-family: PingFangSC-Regular;
    color: rgba(84, 130, 210, 1);
  }
  .rightbox p {
    display: inline-block;
  }
  .rightbox span {
    padding: 0;
    color: rgba(84, 130, 210, 1);
  }
  .icon.icon-fanhui {
    color: #86898e;
    position: absolute;
    top: 3%;
    left: 2%;
    z-index: 2;
    font-weight: bold;
    /*transform: rotate(90deg);*/
  }
  .time {
    width: 0.5625rem;
    height: 0.5625rem;
    position: absolute;
    top: 3%;
    right: 1%;
    color: #5482d1;
  }
  .footer {
    width: 100%;
    height: 40px;
    font-size: 0;
  }
  .footer span {
    width: 50%;
    height: 36px;
    font-size: 0.5rem;
    line-height: 40px;
    display: inline-block;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackRank.vue